<template>
  <section class="site-section expertise-area">
      <div class="site-container">
        <h2 v-if="showTitle"><img src="@/assets/img/svg/icon.svg" alt="Crivelli" width="25">{{ title }}</h2>

        <div class="expertise-area-box-wrapper">
            <div class="expertise-area-box" :style="{transform}" :class="{'mobile-direction-v' : mobileVertical, 'is-small' : small}">
                <div class="expertise-area-item" v-for="item in items" :key="`eai-${item.icon}`">
                    <img :src="require(`@/assets/img/svg/${item.icon}.svg`)" class="icon" v-if="item.icon != null">
                    <h4>{{ item.title }}</h4>
                    <!-- <p>{{ item.text }}</p> -->
                    <router-link :to="{name: 'expertise_area_detail', params: {slug: item.slug}}">Saiba Mais <arrow-horizontal /></router-link>
                </div>
            </div>
        </div>
        <div class="show-mobile" v-if="!mobileVertical">
            <bullets :items="Object.keys(items).map(Number)" :current.sync="mobileCurrentIndex" />
        </div>
      </div>
  </section>
</template>

<script>

import ArrowHorizontal from "@/components/Svg/ArrowHorizontal.vue";
import Bullets from "../Bullets";

export default {

    props: {
        showTitle: {
            type: Boolean,
            default: true,
        },

        title: {
            type: String,
            default: 'Áreas de Atuação'
        },

        mobileVertical: {
            type: Boolean,
            default: false
        },

        items: {
            type: Array
        },

        small: Boolean
    },

    components: {
        ArrowHorizontal,
        Bullets
    },

    computed: {
        transform() {
            return `translateX(${this.mobileCurrentIndex * -100}%)`;
        }
    },

    data() {
        return {
            mobileCurrentIndex: 0,
        }
    }
}
</script>
